import { BusinessUserListResponseItemType } from "@sellar-io/api-v2/types";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../components/modal/Dialog";
import { BusinessUserJobTitleForm } from "../../../components/profileImageUpload/BusinessUserJobTitleForm";

export const UpdateJobTitleModal = ({
  active,
  onDismiss,
  businessUser,
}: {
  active: boolean;
  onDismiss: () => void;
  businessUser: BusinessUserListResponseItemType;
}) => {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Your profile"}
      />
      <DialogContent>
        <BusinessUserJobTitleForm
          businessUserId={parseInt(businessUser.id.toString())}
          jobTitle={businessUser.jobTitle}
          onDismiss={onDismiss}
        />
      </DialogContent>
    </Dialog>
  );
};
